export default {
  install(Vue) {
    Vue.prototype.$toast = function(html, options) {
      this.$bvToast.toast(`${html}`, {
        title: options?.title || 'Внимание',
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: false,
        autoHideDelay: options?.delay || 5000,
        variant: options?.variant || '',
        toastClass: 'e-toast'
      });
    };
  }
};
